export default "__VITE_ASSET__DnDqhYNV__"